import CreateSeedAudiencesNames from './CreateSeedAudiencesNames.Container';

export default CreateSeedAudiencesNames;
